"use strict";

define('rs/models/letter',['rs/models/abstract', 'rs/helper'], function (RSAbstractModel, helper) {
  var LetterModel = RSAbstractModel.extend({
    properties: ['id', 'name', 'templateType', 'active', 'content'],
    serverProperties: ['id', 'name', 'templateType', 'active', 'content'],
    requestLoadById: function requestLoadById() {
      return this.constructor.requestLoadById(this.getId());
    },
    requestUpdate: function requestUpdate(newData) {
      this.applyProperties(newData);
      return this.constructor.requestUpdate(this);
    },
    requestDelete: function requestDelete() {
      return this.constructor.requestDelete(this.getId());
    }
  }, {
    rootURI: '/rs/api/',
    parsers: {
      '#get#letter(?*query)': function getLetterQuery(data) {
        return this.models(data);
      },
      'letter/type/:id': function letter_type_Id(data) {
        return this.models(data);
      },
      '#get#letter/:id': function getLetter_Id(data) {
        return this.model(data);
      },
      '#get#letter/replace/tags/:type': function getLetter_replace_tags_Type(data) {
        return _.map(data, function (tag) {
          return {
            display: helper.parseServerEnum(tag),
            insert: '[' + tag + ']'
          };
        });
      }
    },
    requestLoadById: function requestLoadById(letterId) {
      return this.get('letter/' + letterId);
    },
    requestLoadAll: function requestLoadAll(options) {
      var params = {};
      return this.get('letter', params);
    },
    requestAllByTemplateTypeId: function requestAllByTemplateTypeId(id) {
      return this.get('letter/type/' + id);
    },
    requestCreate: function requestCreate(letterData) {
      return this.post('letter', letterData, {
        jsonBody: true
      });
    },
    requestUpdate: function requestUpdate(letterData) {
      return this.put('letter/' + letterData.getId(), letterData);
    },
    requestDelete: function requestDelete(letterData) {
      return this.del('letter/' + letterData);
    },
    requestReplacementTags: function requestReplacementTags(templateType) {
      return this.get('letter/replace/tags/' + (templateType || 'all'));
    }
  });
  return LetterModel;
});

